import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

class LocalPickup extends Component {
  /** @type {AbortController | undefined} */
  #activeFetch;

  connectedCallback() {
    super.connectedCallback();
    this.#applySelectedLocation();
    this.#bindSelectButtons();

    const closestSection = this.closest(`.shopify-section, dialog`);

    /** @type {(event: VariantUpdateEvent) => void} */
    const variantUpdated = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productUrl = event.detail.data.newProduct.url;
      }

      const variantId = event.detail.resource ? event.detail.resource.id : null;
      const variantAvailable = event.detail.resource ? event.detail.resource.available : null;
      if (variantId !== this.dataset.variantId) {
        if (variantId && variantAvailable) {
          this.removeAttribute('hidden');
          this.dataset.variantId = variantId;
          this.#fetchAvailability(variantId);
        } else {
          this.setAttribute('hidden', '');
        }
      }
    };

    closestSection?.addEventListener(ThemeEvents.variantUpdate, variantUpdated);

    this.disconnectedCallback = () => {
      closestSection?.removeEventListener(ThemeEvents.variantUpdate, variantUpdated);
    };
  }

  #bindSelectButtons() {
    let selectedId = null;
    try {
      const saved = localStorage.getItem('le_selected_location');
      if (saved) selectedId = JSON.parse(saved).id;
    } catch (_e) {}

    this.querySelectorAll('.le-pdp__pickup-dialog-select').forEach((btn) => {
      if (selectedId && String(btn.dataset.locationId) === String(selectedId)) {
        btn.textContent = 'Seleccionado';
        btn.classList.add('le-pdp__pickup-dialog-select--active');
        btn.disabled = true;
        return;
      }
      btn.addEventListener('click', () => {
        const id = btn.dataset.locationId;
        const name = btn.dataset.locationName;
        localStorage.setItem('le_selected_location', JSON.stringify({ id, name }));
        document.cookie = `inventoryInfoApp=${JSON.stringify({ locationId: parseInt(id) })}; path=/; max-age=31536000`;
        window.location.reload();
      });
    });
  }

  #applySelectedLocation() {
    try {
      const saved = localStorage.getItem('le_selected_location');
      if (!saved) return;
      const { id } = JSON.parse(saved);
      if (!id || id === 'domicilio') return;

      const jsonEl = this.querySelector('[data-pickup-availabilities]');
      if (!jsonEl) return;
      const availabilities = JSON.parse(jsonEl.textContent);
      const selectedLocationId = parseInt(id);

      const match = availabilities.find((a) => parseInt(a.locationId) === selectedLocationId);
      if (!match) return;

      // Update name
      const nameEl = this.querySelector('.le-pdp__store-pickup-name');
      if (nameEl) nameEl.textContent = match.name;

      // Update address directly from JSON data
      const addrEl = this.querySelector('.le-pdp__store-pickup-address');
      if (addrEl && match.address) addrEl.innerHTML = match.address;

      // Update phone
      const phoneWrap = this.querySelector('.le-pdp__store-pickup-phone');
      if (phoneWrap) {
        if (match.phone) {
          const link = phoneWrap.querySelector('a');
          if (link) {
            link.href = `https://api.whatsapp.com/send?phone=${match.phone}`;
            link.textContent = match.phone;
          } else {
            phoneWrap.querySelector('span').textContent = match.phone;
          }
          phoneWrap.hidden = false;
        } else {
          phoneWrap.hidden = true;
        }
      }

      // Update stock status
      const stockEl = this.querySelector('.le-pdp__store-pickup-stock');
      const outEl = this.querySelector('.le-pdp__store-pickup-out');
      if (match.available) {
        if (stockEl) { stockEl.textContent = 'En stock'; stockEl.hidden = false; }
        if (outEl) outEl.hidden = true;
        if (!stockEl && outEl) {
          const p = document.createElement('p');
          p.className = 'le-pdp__store-pickup-stock';
          p.textContent = 'En stock';
          outEl.before(p);
          outEl.hidden = true;
        }
      } else {
        if (stockEl) stockEl.hidden = true;
        if (outEl) { outEl.textContent = 'Sin stock en esta sucursal'; outEl.hidden = false; }
        if (!outEl && stockEl) {
          const p = document.createElement('p');
          p.className = 'le-pdp__store-pickup-out';
          p.textContent = 'Sin stock en esta sucursal';
          stockEl.after(p);
          stockEl.hidden = true;
        }
      }
    } catch (_e) {
      // Silently fall back to default (first location)
    }
  }

  #createAbortController() {
    if (this.#activeFetch) this.#activeFetch.abort();
    this.#activeFetch = new AbortController();
    return this.#activeFetch;
  }

  /**
   * Fetches the availability of a variant.
   * @param {string} variantId - The ID of the variant to fetch availability for.
   */
  #fetchAvailability = (variantId) => {
    if (!variantId) return;

    const abortController = this.#createAbortController();

    const url = this.dataset.productUrl;
    fetch(`${url}?variant=${variantId}&section_id=${this.dataset.sectionId}`, {
      signal: abortController.signal,
    })
      .then((response) => response.text())
      .then((text) => {
        if (abortController.signal.aborted) return;

        const html = new DOMParser().parseFromString(text, 'text/html');
        const wrapper = html.querySelector(`local-pickup[data-variant-id="${variantId}"]`);
        if (wrapper) {
          this.removeAttribute('hidden');
          morph(this, wrapper);
          this.#applySelectedLocation();
          this.#bindSelectButtons();
        } else this.setAttribute('hidden', '');
      })
      .catch((_e) => {
        if (abortController.signal.aborted) return;
        this.setAttribute('hidden', '');
      });
  };
}

if (!customElements.get('local-pickup')) {
  customElements.define('local-pickup', LocalPickup);
}
